"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentTypeOptions = void 0;
var types_1 = require("../../types");
exports.documentTypeOptions = new Set([
    { text: "Field Note", value: types_1.ConstructionDocumentType.FIELD_NOTE },
    { text: "Daily Report", value: types_1.ConstructionDocumentType.DAILY_REPORT },
    { text: "RFI", value: types_1.ConstructionDocumentType.RFI },
    { text: "Submittal Item", value: types_1.ConstructionDocumentType.SUBMITTAL },
    {
        text: "Submittal Package",
        value: types_1.ConstructionDocumentType.SUBMITTAL_PACKAGE,
    },
    {
        text: "Change Order Requests",
        value: types_1.ConstructionDocumentType.CHANGE_ORDER,
    },
    { text: "Purchase Order", value: types_1.ConstructionDocumentType.PURCHASE_ORDER },
]);
